import { buildScopedI18n } from '../../utils/buildScopedI18n';
import slaEsCL from './locales/es-CL.json';
import slaEnUS from './locales/en-US.json';
import slaPtBR from './locales/pt-BR.json';

export const escriturasSlaI18n = buildScopedI18n({
  esCL: slaEsCL,
  enUS: slaEnUS,
  ptBR: slaPtBR,
});
